/* Debounce a function by given delay */
// tslint:disable-next-line
export const debounce = (func: any, delay: number) => {
  let inDebounce
  // tslint:disable-next-line
  return function(this: any) {
    const context = this
    const args = arguments
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() => func.apply(context, args), delay)
  }
}



// WEBPACK FOOTER //
// ./src/util/debounce.ts